/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Pagination/theme';

export const PaginationTheme = theme;
